import React from 'react';
import {Counter, cn} from '@chekinapp/ui';
import {COUNTER_GROUPED_ROW_CLASS, COUNTER_ROW_CLASS} from './constants';

type ConfirmCounterProps = {
  title?: string;
  subtitle?: string | React.ReactNode;
  disabled?: boolean;
  readOnly?: boolean;
  value: number;
  onChange: (value: number) => void;
  error?: string;
  maxNumber?: number;
  grouped?: boolean;
};

const CounterStepper = React.forwardRef<HTMLDivElement, ConfirmCounterProps>(
  (
    {title, subtitle, value, onChange, error, disabled, readOnly, maxNumber, grouped},
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'counter-stepper flex w-full items-center gap-3.5',
          grouped ? COUNTER_GROUPED_ROW_CLASS : COUNTER_ROW_CLASS,
          readOnly && 'border-transparent bg-transparent px-0 py-2',
        )}
      >
        <div className="counter-stepper__details min-w-0 flex-1">
          {Boolean(title) && (
            <div
              className={cn(
                'counter-stepper__title leading-tight text-[var(--chekin-color-brand-navy)]',
                grouped ? 'text-[16px] font-semibold' : 'text-[15px] font-medium',
              )}
            >
              {title}
            </div>
          )}
          {Boolean(subtitle) && (
            <div className="counter-stepper__subtitle mt-0.5 text-[13px] leading-snug text-[var(--chekin-text-secondary)]">
              {subtitle}
            </div>
          )}
        </div>
        {readOnly ? (
          <span className="counter-stepper__value grid h-9 min-w-[42px] place-items-center rounded-[12px] bg-[var(--chekin-blue-tint-info)] px-2.5 text-[18px] font-bold tabular-nums text-[var(--chekin-color-brand-navy)]">
            {value}
          </span>
        ) : (
          <Counter
            value={value}
            onChange={onChange}
            disabled={disabled}
            error={error}
            maxNumber={maxNumber}
            className={cn(
              '!w-auto gap-[18px]',
              grouped &&
                'gap-3 [--counter-minus-bg:var(--chekin-color-white)] [--counter-minus-border:transparent] [--counter-plus-shadow:none] [--counter-value-font-weight:700] [&_button]:size-11 desk:[&_button]:size-9 [&_button]:rounded-[14px] [&_svg]:size-[18px] [&>span]:min-w-[26px] [&>span]:text-[22px]',
            )}
          />
        )}
      </div>
    );
  },
);

export {CounterStepper};
